import { cn } from '@/lib/utils';

import { Spinner } from './Spinner';

interface LoadingStateProps {
  label?: string;
  /** 화면 전체 중앙(가드·초기 로딩). */
  fullscreen?: boolean;
  className?: string;
}

/** 로딩 상태 블록 — 스피너 + 라벨. 카드/페이지/전체화면 공용(FO 라우터 폴백 포함). */
export function LoadingState({
  label = '불러오는 중입니다',
  fullscreen,
  className,
}: LoadingStateProps) {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center gap-3 text-sm text-muted-foreground',
        fullscreen ? 'min-h-screen' : 'min-h-44 py-10',
        className,
      )}
      aria-busy="true"
    >
      <Spinner className="size-8" label={label} />
      <span>{label}</span>
    </div>
  );
}
